var _excluded = ["id", "buttonNode", "buttonProps", "buttonText", "color", "width", "height", "size", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'pcln-design-system';
import { ChevronDown } from 'pcln-icons';
import Popover from 'pcln-popover';
import MenuList from '../MenuList';
var LinkButton = styled(Button).withConfig({
  displayName: "Menu__LinkButton",
  componentId: "sc-1mj8ibm-0"
})(["display:flex;align-items:center;"]);

function Menu(_ref) {
  var id = _ref.id,
      buttonNode = _ref.buttonNode,
      buttonProps = _ref.buttonProps,
      buttonText = _ref.buttonText,
      color = _ref.color,
      width = _ref.width,
      height = _ref.height,
      size = _ref.size,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var MenuContent = function MenuContent(_ref2) {
    var handleClose = _ref2.handleClose;
    return /*#__PURE__*/React.createElement(MenuList, {
      id: id,
      color: color,
      size: size,
      height: height,
      handleClose: handleClose
    }, children);
  };

  MenuContent.propTypes = {
    handleClose: PropTypes.func
  };
  var onKeyDown = useCallback(function (evt) {
    var key = evt.key;

    if (key === 'ArrowDown' || key === 'ArrowUp') {
      evt.preventDefault();
      evt.target.click();
    }
  }, []);

  var ClickableNode = function ClickableNode(props) {
    return buttonNode ? /*#__PURE__*/React.cloneElement(buttonNode, _objectSpread({
      onKeyDown: onKeyDown
    }, props)) : /*#__PURE__*/React.createElement(LinkButton, _extends({
      variation: "link"
    }, props, {
      p: 2
    }, buttonProps, {
      onKeyDown: onKeyDown
    }), buttonText, /*#__PURE__*/React.createElement(ChevronDown, {
      ml: 1
    }));
  };

  return /*#__PURE__*/React.createElement(Popover, _extends({
    hideArrow: true,
    trapFocus: true,
    width: width,
    zIndex: 1600,
    placement: "bottom",
    "aria-controls": id,
    renderContent: MenuContent
  }, props), /*#__PURE__*/React.createElement(ClickableNode, null));
}

Menu.displayName = 'Menu';
Menu.propTypes = {
  id: PropTypes.string,
  buttonNode: PropTypes.node,
  buttonProps: PropTypes.shape(Button.propTypes),
  buttonText: PropTypes.node,
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
  size: PropTypes.string,
  children: PropTypes.node
};
Menu.defaultProps = {
  width: '650px',
  size: 'singleColumn'
};
export default Menu;